import { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const ErrorSnackBarIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="2 2 24 24"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M18.6443 9.76409C18.6443 9.64623 18.5478 9.5498 18.43 9.5498L16.6621 9.55784L13.9996 12.7319L11.3398 9.56052L9.56927 9.55248C9.45141 9.55248 9.35498 9.64623 9.35498 9.76677C9.35498 9.81766 9.37373 9.86588 9.40587 9.90606L12.8907 14.0578L9.40587 18.2069C9.37351 18.2462 9.35555 18.2954 9.35498 18.3462C9.35498 18.4641 9.45141 18.5605 9.56927 18.5605L11.3398 18.5525L13.9996 15.3784L16.6594 18.5498L18.4273 18.5578C18.5452 18.5578 18.6416 18.4641 18.6416 18.3436C18.6416 18.2927 18.6228 18.2444 18.5907 18.2043L15.1112 14.0552L18.5961 9.90338C18.6282 9.86588 18.6443 9.81498 18.6443 9.76409Z"
        fill="currentColor"
      />
      <path
        d="M14 2C7.37321 2 2 7.37321 2 14C2 20.6268 7.37321 26 14 26C20.6268 26 26 20.6268 26 14C26 7.37321 20.6268 2 14 2ZM14 23.9643C8.49821 23.9643 4.03571 19.5018 4.03571 14C4.03571 8.49821 8.49821 4.03571 14 4.03571C19.5018 4.03571 23.9643 8.49821 23.9643 14C23.9643 19.5018 19.5018 23.9643 14 23.9643Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(ErrorSnackBarIcon);
